import {
  GET_ALL_INVITADOS,
  LOADING_GETALL_INVITADOS,
  SET_ACTIVO_INVITADOS,
  SET_LOGOUT,
  PARAMS_INVITADOS,
} from '../../store/Types';

const initialState = {
  all: [],
  loadingGetAll: false,
  meta: null,
  links: null,
  activo: null,
  params: {},
};

export const invitadosReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_ALL_INVITADOS:
      return {
        ...state,
        all: action.payload.data,
        links: action.payload.links,
        meta: action.payload.meta,
      };
    case SET_ACTIVO_INVITADOS:
      return {
        ...state,
        activo: action.payload,
      };
    case SET_LOGOUT:
      return {
        ...state,
        ...initialState,
      };
    case LOADING_GETALL_INVITADOS:
      return {
        ...state,
        loadingGetAll: action.payload,
      };
    case PARAMS_INVITADOS:
      return {
        ...state,
        params: action.payload,
      };
    default:
      return state;
  }
};
